import * as globalTypes from '../../mutation-types'
import zipCodeAPI from '../../../api/zipcode.js'
import { Store } from 'vuex';


export const getApprovedZipCodes =  async ({dispatch, commit}, zipCode) => {
  var data = "";
  try {
    data = await zipCodeAPI.getApprovedZipCodes(zipCode);
  }
  catch(e) {
    if(e.response !== undefined && e.response.status === 404) {
      let msg = "Zip code is not approved.";
      dispatch('showError', msg, {root:true} )
      throw msg;
    }
    else {
      let msg = "There was an error in checking the zip code.";
      dispatch('showError', msg, {root:true} )
      throw msg;
    }
  }

  try {
    var results = (await zipCodeAPI.getStateFromZipCode(zipCode)).data;
    return {data: results, locID: data.data.locId};
  }
  catch(e) {
    let msg = "There was an error in getting the state for the approved zip code.";
    dispatch('showError', msg, {root:true} )
    throw msg;
  }
}

export const getMarket = async({dispatch, commit}, locID) => {  
  try {
    var results = (await zipCodeAPI.getMarketFromLocID(locID)).data;
    // console.log("RESULTS: ", results)
    return results;
  }
  catch(e) {
    let msg = "There was an error in getting the state for the approved zip code.";
    dispatch('showError', msg, {root:true} )
    throw msg;
  }
}

export const getAllMarkets = async({dispatch, commit}) => {  
  try {
    var results = (await zipCodeAPI.getAllMarkets()).data;
    return results;
  }
  catch(e) {
    let msg = "There was an error in getting the state for the approved zip code.";
    dispatch('showError', msg, {root:true} )
    throw msg;
  }
}








// WEBPACK FOOTER //
// ./src/store/modules/zipcodes/actions.js